import { Injectable } from "@angular/core";
import { IQuestionnaire, SPECIFIC_USE } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";

/**
 * Compatibility adapter required by the shared knowledge editor package.
 *
 * The package always asks for questionnaire data when its media editor starts,
 * even when the quiz UI is disabled. Returning empty collections here keeps the
 * EU-CIP editor free of quiz API calls while preserving the package contract.
 */
@Injectable({
  providedIn: "root",
})
export class QuizDisabledQuestionnaireService {
  public getSpecificQuestionnaireListWithLang(_lang: string, _specificUse: SPECIFIC_USE): Observable<IQuestionnaire[]> {
    return of([]);
  }

  public getSpecificQuestionnaireList(_specificUse: SPECIFIC_USE): Promise<IQuestionnaire[]> {
    return Promise.resolve([]);
  }

  public linkQuestionnaireToMedia(
    _questionnaireId: string,
    _questionnaireVersion: string,
    _knowledgeId: string,
    _mediaId: string
  ): Promise<IQuestionnaire> {
    return Promise.resolve(null);
  }
}
